import React, {isValidElement} from "react"
import {Alert, AlertProps} from "@mui/material"
import {styled} from "@cirrus/ui-kit/src"
import {IWarnings} from "./types"
import WarningMessage = IWarnings.WarningMessage

export const Warning = ({message, ...props}: AlertProps & {message: WarningMessage}) => <CustomAlert severity="warning" {...props}>
	{isValidElement(message) ? message : <div dangerouslySetInnerHTML={{__html: message}}/>}
</CustomAlert>

const CustomAlert = styled(Alert)({
	"&.MuiAlert-root": {
		"& .MuiAlert-icon": {
			color: "rgb(190, 166, 110)",
			marginRight: "1.6rem",
		},
		borderRadius: 4,
		borderStyle: "solid",
		borderWidth: 1,
		fontSize: "1.3rem",
		fontWeight: "bold",
		padding: [[".5rem", "1.6re"]],
	},
	"&.MuiAlert-standardWarning": {
		backgroundColor: "#F6E8CD",
		borderColor: "#BEA66E",
		color: "#333",
	},
})
